import { Box, TabList, Tab, TabPanel, TabPanels, Tabs, useMediaQuery, theme, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import { Paper, SelectField } from '../common';
import { tabs } from './navigation';

export const EquipsUnitsPage = () => {
  const [isSmall] = useMediaQuery('(max-width: 768px)', {
    fallback: true
  });

  if(isSmall) {return <EquipsUnitsMobilePage />;}
  return <Box>
    <Paper>
      <Tabs isLazy>
        <TabList>
          {tabs.map((tab, index) => <Tab key={index} >{tab.name}</Tab>)}
        </TabList>
        <TabPanels >
          {tabs.map(({ component: Component }, index) => <TabPanel key={index}><Component /></TabPanel>)}
        </TabPanels>
      </Tabs>
    </Paper>
  </Box>;
};

const EquipsUnitsMobilePage = () => {
  const [currentTab, setCurrentTab] = useState(tabs[0]);

  const Tab = currentTab.component;

  return <Box>
    <Paper>
      <Flex direction='column' gap={5}>
        <Box mx={4} mt={4}>
          <SelectField 
            id='tab'
            label='Справочник'
            value={currentTab}
            options={tabs}
            onChange={setCurrentTab}
            clearable={false}
          />
        </Box>
        <Box>
          <Tab />
        </Box>
      </Flex>
    </Paper>
  </Box>;
};